import { createSlice } from '@reduxjs/toolkit'
import initialState from "./initialState";
import reducers from "./reducers";
import { elementAuth } from "./thunks";
import { TrackingService } from "../../Services/TrackingService";
import UrlParams from "../../Utils/UrlParams";

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers,
  extraReducers: (builder) => {
    builder
      .addCase(elementAuth.fulfilled, (state, action) => {
        const assets = action?.payload;
        const referrer = document.referrer && new URL(document.referrer)
        if (assets && assets.token !== '') {
          state.session = assets.encryptedToken;
          state.configs = {...assets.elements.configs};
          state.env = assets.elements.configs.env;
          state.productionReady = assets.productionReady;
          state.loading = false;
          state.liquidAnalytics = assets.liquidAnalytics;
          state.element = assets.elementReq
          state.productCols = assets.elementReq === 'product' ?
            assets.elements.configs.general.details ? 2 : 1 : 2
          state.liquidToken = assets.token;
          state.secure = state.configs.env?.allowLocal ? state.configs.env?.allowLocal :
            state.configs.env.live && referrer.hostname.endsWith(state.configs.env.production) ?
              referrer.hostname.endsWith(state.configs.env.production) :
              state.configs.env.staging.includes(referrer.hostname)

          const params = new UrlParams(window.location.search)
          if(params.get("demo") === "true") {
            state.secure = true
          }

          if(state.liquidAnalytics.active) {
            TrackingService.startTracking({
              ga: state.liquidAnalytics.ga,
              gtm: [state.liquidAnalytics.gtm]
            })
          }
        } else {
          state.secure = false
          state.token = ''
        }
      })
      .addCase(elementAuth.pending, (state) => {
        state.loading = true
      })
      .addCase(elementAuth.rejected, (state) => {
        state.secure = false;
        state.loading = false;
        state.token = '';
      })
  }
})

export const {
  setCurrentRouteKey,
  setLayoutType,
  setPreviousLayoutType,
  setInIframe,
  setInSecure,
  setDynamicStyles,
  setConfigs,
  setProductCols
} = authSlice.actions

const reducer = authSlice.reducer
export default reducer
